import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DateService {
  constructor() {}

  convertDateToStartOfTheDay(date: Date): number {
    return Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      0,
      0,
      0,
      0,
    );
  }

  convertDateToEndOfTheDay(date: Date): number {
    return Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      23,
      59,
      0,
      0,
    );
  }

  getToday(): Date {
    return new Date();
  }

  getYesterday(): Date {
    return new Date(new Date().setDate(new Date().getDate() - 1));
  }

  getThisWeek(): Date[] {
    const currWeek = new Date(); // get current date
    const firstThisWeek = currWeek.getDate() - currWeek.getDay(); // First day is the day of the month - the day of the week
    const lastThisWeek = firstThisWeek + 6; // last day is the first day + 6
    const firstdayThisWeek = new Date(
      new Date(currWeek.setDate(firstThisWeek + 1)).setHours(0, 0, 0, 0),
    );
    const lastdayThisWeek = new Date(
      new Date(currWeek.setDate(lastThisWeek + 1)).setHours(0, 0, 0, 0),
    );

    return [firstdayThisWeek, lastdayThisWeek];
  }

  getLastWeek(): Date[] {
    const currLastWeek = new Date(); // get current date
    const dayLastWeek = new Date(
      new Date().setDate(currLastWeek.getDate() - 7),
    );
    const firstLastWeek = dayLastWeek.getDate() - dayLastWeek.getDay(); // First day is the day of the month - the day of the week
    const lastLastWeek = firstLastWeek + 6; // last day is the first day + 6
    const firstdayLastWeek = new Date(
      new Date(currLastWeek.setDate(firstLastWeek + 1)).setHours(0, 0, 0, 0),
    );
    const lastdayLastWeek = new Date(
      new Date(currLastWeek.setDate(lastLastWeek + 1)).setHours(0, 0, 0, 0),
    );

    return [firstdayLastWeek, lastdayLastWeek];
  }

  getThisMonth(): Date[] {
    const currMonth = new Date(); // get current date
    const firstdayThisMonth = new Date(
      new Date(currMonth.setDate(1)).setHours(0, 0, 0, 0),
    );
    const lastdayThisMonth = new Date(
      new Date(currMonth.getFullYear(), currMonth.getMonth() + 1, 0).setHours(
        23,
        59,
        0,
        0,
      ),
    );

    return [firstdayThisMonth, lastdayThisMonth];
  }

  getLastMonth(): Date[] {
    const currLastMonth = new Date(); // get current date
    currLastMonth.setDate(1);
    currLastMonth.setMonth(currLastMonth.getMonth() - 1);
    const firstdayLastMonth = new Date(
      new Date(currLastMonth.setDate(1)).setHours(0, 0, 0, 0),
    );
    const lastdayLastMonth = new Date(
      new Date(
        currLastMonth.getFullYear(),
        currLastMonth.getMonth() + 1,
        0,
      ).setHours(23, 59, 0, 0),
    );

    return [firstdayLastMonth, lastdayLastMonth];
  }
}
